import React, { Suspense, useEffect } from "react";
import CareerIndividualInputFields from "../components/CareerIndividualInputFields";
import CareerIndividualJobDescription from "../components/CareerIndividualJobDescription";
import CareerIndividualJobDescriptionCard from "../components/CareerIndividualJobDescriptionCard";
import { useDispatch, useSelector } from "react-redux";
import { env } from "../config";
import axios from "axios";
import * as Actions from "../redux/actions";
import { useLocation } from "react-router";
import Loader from "../components/Loader";
import Footer from "../components/Footer";
const CareerIndividualIntro = React.lazy(
  () => import("../components/CareerIndividualIntro")
);

function CareerIndividualPage() {
  const location = useLocation();
  const dispatch = useDispatch();
  const JobList: any = useSelector(
    (state: any) => state?.Page?.CareerIndividualarray
  );

  const getJobListData = () => {
    axios.get(`${env}/api/job-lists?populate=deep`).then(function (response) {
      dispatch(Actions.CareerIndividualAction(response?.data?.data));
    });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 1,
      behavior: "smooth",
    });
    if (Object.keys(JobList)?.length === 0) {
      getJobListData();
    }
  }, []);

  const isLoading = Object.keys(JobList)?.length === 0;

  return (
    <div>
      <Suspense fallback={<Loader />}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <CareerIndividualIntro
              startId={location?.state?.id?.id}
              JobList={JobList}
            />
            <Footer />
          </>
        )}
      </Suspense>
    </div>
  );
}

export default CareerIndividualPage;
